module.exports = __webpack_public_path__ + "images/category_lp/pc/user1_59f271bffc590b35c2ffdb0a690b1331.png";